import MuiTypography from '@mui/material/Typography';

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 25,
    },
    sort: {
      by: 'marina',
      direction: 'asc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'id',
      key: 'id',
      sort_key: 'id',
      sortable: true,
      label: 'ID',
      width: 50,
    },
    {
      id: 'attributes.code',
      key: 'code',
      sort_key: 'code',
      sortable: true,
      label: 'CODE',
      width: 50,
    },
    {
      id: 'attributes.location',
      key: 'location',
      sort_key: 'location',
      sortable: true,
      label: 'Location',
    },

    {
      id: 'attributes.marina',
      key: 'marina',
      sort_key: 'marina',
      sortable: true,
      label: 'MARINA',
    },
    {
      id: 'attributes.area',
      key: 'area',
      sort_key: 'area',
      sortable: true,
      label: 'AREA',
    },
  ],
  render: {
    formatHead: (key, value) => {
      switch (key) {
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value.toUpperCase()}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick) => {
      switch (key) {
        case 'id':
        case 'code': {
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold' }}
              onClick={onClick}
            >
              {value || '-'}
            </MuiTypography>
          );
        }
        default:
          return (
            <MuiTypography variant='body1' onClick={onClick}>
              {value || '-'}
            </MuiTypography>
          );
      }
    },
  },
};
